
export enum LayoutStyle {
    List = 'list',
    HorizontalCard = 'horizontal-card'
}

export interface IPaginatedLandingContent {
    title: string;
    description: string;
    url: string;
    date: string | null;
    imageUrl: string;
    topics: any[];
    roles: any[];
    ages: any[];
    contentTypes: any[];
    specialties: any[];
}

export enum PillColor {
    BlueT1 = 'blue-t1',
    GreenT1 = 'green-t1',
    YellowT1 = 'yellow-t1',
    BlueVioletT1 = 'blue-violet-t1',
    RedT1 = 'red-t1'
}